import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _14_POLLINATTION:Partial<EcosystemServiceModel> ={
  id:'pollination',
  pos:14,
  image: "/images/ecoservices/pollination.jpg",
  code: ["2.2.2.1"],
  unit:'pollination',
  assetType:'species',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "kg",
      element: "crops",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
        { id: "pollinationDependency", name: "Pollination Species Dependency Factor", included: true },
      ],
      valueIndices: []
    }
  ]

}
